import CustomCard from "components/Atoms/CustomCard"
import IFrame from "components/Atoms/IFrame"
import NoResults from "components/Organisms/NoResults"
import { MetabaseUrlInput, useMetabaseUrlQuery } from "generated/graphql"

import React from "react"

type MetabaseAnalyticsCardProps = {
  filter: MetabaseUrlInput
}
const MetabaseAnalyticsCard = ({ filter }: MetabaseAnalyticsCardProps) => {
  const { data, loading, error } = useMetabaseUrlQuery({
    variables: { filter },
  })

  if (loading) return null
  if (error || !data?.metabaseUrl)
    return <NoResults title="Unable to fetch the analytics" />

  const iframeUrl = data.metabaseUrl.iframeUrl

  return (
    <CustomCard className="w-full h-content p-0 rounded-md">
      <IFrame src={iframeUrl} allowTransparency className="h-full w-full" />
    </CustomCard>
  )
}

export default MetabaseAnalyticsCard
